import ReactGA from "react-ga4";


// export const createAnalyticsEventTracker= (category = "ROP Root") => {
//     const eventTracker = (action = "Default Action", label = "Default Label",data) => {
//         ReactGA.event({
//             category,
//             action,
//             label,
//             ...data
//         });
//     };

//     return eventTracker;
// }

export const createAnalyticsPageTracker = (hitType = "pageview") => {
    const pageTracker = (page = "Default Page",title= "Default Title") => {
        ReactGA.send({
            hitType,
            page,
            title,
        });
    };
    return pageTracker;
}
